import { render } from "./uploadFiles.vue?vue&type=template&id=7136a0b9&scoped=true"
import script from "./uploadFiles.vue?vue&type=script&lang=js"
export * from "./uploadFiles.vue?vue&type=script&lang=js"

import "./uploadFiles.vue?vue&type=style&index=0&id=7136a0b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7136a0b9"]])

export default __exports__